@if (!loaded) {
  <se-fe-spinner
    [seFeDataSize]="900"
    [seFeDataCenter]="true">
  </se-fe-spinner>
}
@if (loaded) {
  <se-fe-list>
    @for (listItem of listItems; track listItem) {
      <se-fe-list-item>
        <se-fe-header [seFeDataSubtitle]="listItem.subtitle" [seFeDataSize]="600">
          <div seFeHeaderTitle class="registration-list-title">
            <a seFeLink="low" [href]="listItem.url">
              {{ listItem.title }}
            </a>
          </div>
        </se-fe-header>
      </se-fe-list-item>
    }
  </se-fe-list>
}
@if (loaded && !listItems.length) {
  <se-fe-empty-state seFeDataTitle="No Registrations Found">
    <se-fe-icon seFeEmptyStateIcon seFeDataName="spot_whistle" seFeDataSize="950"></se-fe-icon>
  </se-fe-empty-state>
}
